"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import Image from "next/image";
import { motion, useReducedMotion } from "framer-motion";
import { FaChevronRight } from "react-icons/fa";
import GradientButton from "@/components/ui/GradientButton";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
interface HireShopifyDevelopersProps {
  imageSrc?: string;
  imageAlt?: string;
}
export default function HireShopifyDevelopers(t0) {
  const $ = _c(43);
  const {
    imageSrc: t1,
    imageAlt: t2
  } = t0;
  const imageSrc = t1 === undefined ? "/images/shopify/hiring.png" : t1;
  const imageAlt = t2 === undefined ? "Hire Shopify Developers From The Dezine" : t2;
  const desktopAnimations = useDesktopAnimations();
  useReducedMotion();
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="pointer-events-none absolute inset-0 opacity-40 bg-[radial-gradient(circle,rgba(75,88,125,.18)_0.8px,transparent_0.9px)] bg-[length:12px_12px]" aria-hidden="true" />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== desktopAnimations) {
    t4 = desktopAnimations ? {
      opacity: 0,
      x: -40
    } : false;
    $[1] = desktopAnimations;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== desktopAnimations) {
    t5 = desktopAnimations ? {
      opacity: 1,
      x: 0
    } : undefined;
    $[3] = desktopAnimations;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== desktopAnimations) {
    t6 = desktopAnimations ? undefined : {
      opacity: 1,
      x: 0
    };
    $[5] = desktopAnimations;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      once: true,
      amount: 0.2
    };
    t8 = {
      duration: 0.8,
      ease
    };
    $[7] = t7;
    $[8] = t8;
  } else {
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] !== desktopAnimations) {
    t9 = desktopAnimations ? {
      y: [0, -10, 0]
    } : undefined;
    $[9] = desktopAnimations;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== desktopAnimations) {
    t10 = desktopAnimations ? {
      duration: 5,
      repeat: Infinity,
      ease: "easeInOut"
    } : undefined;
    $[11] = desktopAnimations;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== imageAlt || $[14] !== imageSrc) {
    t11 = <Image src={imageSrc} alt={imageAlt} width={560} height={500} className="h-auto w-full object-contain drop-shadow-sm transition-transform duration-300 hover:scale-[1.02]" loading="lazy" />;
    $[13] = imageAlt;
    $[14] = imageSrc;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t10 || $[17] !== t11 || $[18] !== t9) {
    t12 = <motion.div animate={t9} transition={t10} className="relative flex w-full max-w-[480px] items-center justify-center">{t11}</motion.div>;
    $[16] = t10;
    $[17] = t11;
    $[18] = t9;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12 || $[21] !== t4 || $[22] !== t5 || $[23] !== t6) {
    t13 = <motion.div initial={t4} whileInView={t5} animate={t6} viewport={t7} transition={t8} className="flex justify-center lg:col-span-5">{t12}</motion.div>;
    $[20] = t12;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== desktopAnimations) {
    t14 = desktopAnimations ? {
      opacity: 0,
      x: 40
    } : false;
    $[25] = desktopAnimations;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== desktopAnimations) {
    t15 = desktopAnimations ? {
      opacity: 1,
      x: 0
    } : undefined;
    $[27] = desktopAnimations;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== desktopAnimations) {
    t16 = desktopAnimations ? undefined : {
      opacity: 1,
      x: 0
    };
    $[29] = desktopAnimations;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  let t18;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      once: true,
      amount: 0.2
    };
    t18 = {
      duration: 0.8,
      delay: 0.1,
      ease
    };
    $[31] = t17;
    $[32] = t18;
  } else {
    t17 = $[31];
    t18 = $[32];
  }
  let t19;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <h2 className="font-poppins mb-6 text-[28px] font-bold leading-[1.22] tracking-tight text-[#0b1354] sm:text-[34px] lg:text-[40px] dark:text-white">Hire Shopify Developers<span className="block">From The Dezine</span></h2>;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="space-y-4 font-sans text-[15px] leading-[1.75] text-[#5e6282] sm:text-[16px] dark:text-gray-300"><p>Do you want a Shopify expert to help you start your eCommerce business journey? Being a leading Shopify development company, we hold a professional team of Shopify programmers, coders, and consultants to help entrepreneurs build their Shopify eCommerce stores and websites.</p><p>Worried about the budget? We help you unlock your Shopify stores on a budget. Hire remote Shopify programmers full-time or hourly as per your project needs and budget with no compromise in commitment and attention to your solutions.</p><p>Browse expert Shopify developer profiles to find and choose the best Shopify coders having in-depth knowledge and a successful record of serving clients successfully.</p></div>;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="mt-8"><GradientButton href="/contact" variant="pink-purple" className=""><span>Contact Us</span><FaChevronRight className="ml-1 text-[12px]" /></GradientButton></div>;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== t14 || $[37] !== t15 || $[38] !== t16) {
    t22 = <motion.div initial={t14} whileInView={t15} animate={t16} viewport={t17} transition={t18} className="flex flex-col items-start lg:col-span-7">{t19}{t20}{t21}</motion.div>;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t13 || $[41] !== t22) {
    t23 = <section className="relative overflow-hidden bg-white py-16 transition-colors duration-300 sm:py-20 lg:py-24 dark:bg-[#0b0f19]">{t3}<div className="relative z-10 mx-auto w-full max-w-[1280px] px-4 sm:px-6 lg:px-8"><div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-16">{t13}{t22}</div></div></section>;
    $[40] = t13;
    $[41] = t22;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  return t23;
}